import { PATIENT_TRACKING_EVENTS, PatientTrackingEventName } from '@physiofit-digital/physiofit_types';

/** Pfad (relativ, ohne trailing slash) → shown-Event. */
export const ONBOARDING_SHOWN_EVENT_BY_PATH: Record<string, PatientTrackingEventName> = {
  '/webAppOnboarding': PATIENT_TRACKING_EVENTS.web_welcome_shown,
  '/webAppOnboarding/phone-verification': PATIENT_TRACKING_EVENTS.web_phone_verify_shown,
  '/webAppOnboarding/insurance-select': PATIENT_TRACKING_EVENTS.web_insurance_select_shown,
  '/webAppOnboarding/insurance-invoice-explain': PATIENT_TRACKING_EVENTS.web_insurance_process_overview_shown,
  '/webAppOnboarding/insurance-blocked-free-process-overview': PATIENT_TRACKING_EVENTS.web_insurance_process_overview_shown,
  '/webAppOnboarding/insurance-blocked-practice-fee-process-overview':
    PATIENT_TRACKING_EVENTS.web_insurance_process_overview_shown,
  '/webAppOnboarding/insurance-blocked-temp-process-overview': PATIENT_TRACKING_EVENTS.web_insurance_process_overview_shown,
  '/webAppOnboarding/insurance-abtretung-process-overview': PATIENT_TRACKING_EVENTS.web_insurance_process_overview_shown,
  '/webAppOnboarding/insurance-bnpl-process-overview': PATIENT_TRACKING_EVENTS.web_insurance_process_overview_shown,
  '/webAppOnboarding/insurance-without-abtretung-physiofit-process-overview': PATIENT_TRACKING_EVENTS.web_insurance_process_overview_shown,
  '/webAppOnboarding/insurance-without-abtretung-patient-process-overview': PATIENT_TRACKING_EVENTS.web_insurance_process_overview_shown,
  '/webAppOnboarding/course-not-certified-process-overview': PATIENT_TRACKING_EVENTS.web_insurance_process_overview_shown,
  '/webAppOnboarding/insurance-bnpl-checkout': PATIENT_TRACKING_EVENTS.web_insurance_bnpl_checkout_shown,
  '/webAppOnboarding/insurance-bnpl-payment': PATIENT_TRACKING_EVENTS.web_insurance_bnpl_order_shown,
  '/webAppOnboarding/install': PATIENT_TRACKING_EVENTS.web_install_shown,
};

/** processType-Property für die konsolidierten Versicherungs-Übersichten. */
export const ONBOARDING_PROCESS_TYPE_BY_PATH: Record<string, string> = {
  '/webAppOnboarding/insurance-invoice-explain': 'invoice',
  '/webAppOnboarding/insurance-blocked-free-process-overview': 'blockedFree',
  '/webAppOnboarding/insurance-blocked-practice-fee-process-overview': 'blockedPracticeFee',
  '/webAppOnboarding/insurance-blocked-temp-process-overview': 'blockedTemp',
  '/webAppOnboarding/insurance-abtretung-process-overview': 'abtretung',
  '/webAppOnboarding/insurance-bnpl-process-overview': 'bnpl',
  '/webAppOnboarding/insurance-without-abtretung-physiofit-process-overview': 'withoutAbtretungPhysiofit',
  '/webAppOnboarding/insurance-without-abtretung-patient-process-overview': 'withoutAbtretungPatient',
  '/webAppOnboarding/course-not-certified-process-overview': 'courseNotCertified',
};
